export const SIZES = [
  {
    labels: ["xxx-large", "xxxlarge", "xxx-lg", "xxxlg"],
    label: "xxx-lg",
  },
  {
    labels: ["xx-large", "xxlarge", "xx-lg", "xxlg"],
    label: "xx-lg",
  },
  {
    labels: ["x-large", "xlarge", "x-lg", "xlg"],
    label: "x-lg",
  },
  {
    labels: ["large", "lg"],
    label: "lg",
  },
  {
    labels: ["medium", "md"],
    label: "md",
  },
  {
    labels: ["small", "sm"],
    label: "sm",
  },
  {
    labels: ["x-small", "xsmall", "x-sm", "xsm"],
    label: "x-sm",
  },
];
